import { render, staticRenderFns } from "./TagAdderDialog.vue?vue&type=template&id=f5d51f2a"
import script from "./TagAdderDialog.vue?vue&type=script&lang=js"
export * from "./TagAdderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports